import { Postrequestcall } from "../request/Postrequest";
import { FETCH_POST_IDS } from "../constant/Apipath";
import { setCommunityPostIds } from "../redux/actions/actions";

export const fetchAndStoreCommunityPostIds = async (userId, accessToken, dispatch) => {
  if (!userId || !accessToken) return;
  try {
    const payload = {
      PageNo: 1,
      PageSize: 0,
      UserId: Number(userId),
      FormatTypeId: 0,
      AppName: "All",
      LastKnownId: 0
    };
    const response = await Postrequestcall(FETCH_POST_IDS, payload, accessToken);
    if (response?.status === 200) {
      const fetchedData = response?.data?.data;
      if (Array.isArray(fetchedData) && fetchedData.length > 0) {
        const grouped = {
          all: [],
          products: [],
          projects: [],
          trades: []
        };
        for (const item of fetchedData) {
          if (!item.id) continue;
          grouped.all.push(item);
          switch (item.appName) {
            case "Product":
              grouped.products.push(item);
              break;
            case "UserSiteProject":
              grouped.projects.push(item);
              break;
            case "Trade":
              grouped.trades.push(item);
              break;
            default:
              break;
          }
        }
        dispatch(setCommunityPostIds(grouped));
      }
    }
  } catch (error) {
    console.error("fetchAndStoreCommunityPostIds -> Error:", error);
  }
};
